const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398.9 135.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.28,
    y: 38.54,
    transform: "translate(433.44 -295.99) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.9,121.15h-68.38V16.3h68.38v104.86ZM338.52,113.15h52.38V24.3h-52.38v88.86Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.13-.46h126.42v103.93c0,19-15.43,34.43-34.43,34.43h-57.55c-19,0-34.43-15.43-34.43-34.43V-.46h0Z",
    transform: "translate(334.07 -196.61) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.52,135.93h-107.93c-21.19,0-38.43-17.24-38.43-38.43v-57.55c0-21.19,17.24-38.43,38.43-38.43h107.93v134.42ZM230.59,9.52c-16.78,0-30.43,13.65-30.43,30.43v57.55c0,16.78,13.65,30.43,30.43,30.43h99.93V9.52h-99.93Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.18,55.11h-20.94c-2.21,0-4-1.79-4-4s1.79-4,4-4h20.94c2.21,0,4,1.79,4,4s-1.79,4-4,4Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.18,90.34h-20.94c-2.21,0-4-1.79-4-4s1.79-4,4-4h20.94c2.21,0,4,1.79,4,4s-1.79,4-4,4Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.16,72.73h-96.32c-16.33,0-29.62-13.29-29.62-29.62,0-11.92-9.7-21.62-21.62-21.62H4c-2.21,0-4-1.79-4-4s1.79-4,4-4h44.6c16.33,0,29.62,13.29,29.62,29.62,0,11.92,9.7,21.62,21.62,21.62h96.32c2.21,0,4,1.79,4,4s-1.79,4-4,4Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.69,
    cy: 65.02,
    r: 61.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.69,130.04c-35.85,0-65.02-29.17-65.02-65.02S74.83,0,110.69,0s65.02,29.17,65.02,65.02-29.17,65.02-65.02,65.02ZM110.69,8c-31.44,0-57.02,25.58-57.02,57.02s25.58,57.02,57.02,57.02,57.02-25.58,57.02-57.02-25.58-57.02-57.02-57.02Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.02,116.4c-.61,0-1.22-.14-1.8-.43-1.97-1-2.76-3.41-1.76-5.38l21.06-41.57h-30.68l26.94-53.19c1-1.97,3.41-2.76,5.38-1.76,1.97,1,2.76,3.41,1.76,5.38l-21.06,41.57h30.68l-26.94,53.19c-.71,1.39-2.11,2.19-3.57,2.19Z",
    style: {
      fill: "#231f20"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerPlug);
export default __webpack_public_path__ + "static/media/power-plug.f4caaba29eee4781d384ec835611d19e.svg";
export { ForwardRef as ReactComponent };